import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b445ec3a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "portal-home" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HomeHeader = _resolveComponent("HomeHeader")!
  const _component_HomeList = _resolveComponent("HomeList")!
  const _component_HomeFooter = _resolveComponent("HomeFooter")!
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_openBlock(), _createBlock(_component_a_spin, {
    spinning: _ctx.loading,
    style: {"padding-top":"20vh"}
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _withDirectives(_createElementVNode("div", null, [
          _createElementVNode("div", null, [
            _createVNode(_component_HomeHeader),
            _createVNode(_component_HomeList)
          ]),
          _createVNode(_component_HomeFooter)
        ], 512), [
          [_vShow, !_ctx.loading]
        ])
      ])
    ]),
    _: 1
  }, 8, ["spinning"]))
}